<div>
  <div class="singlemedia">
    <div class="container">
      <a href="/media" class="btnstyl1"><i class="fa fa-angle-double-left" aria-hidden="true"></i> All Media</a>

      <h5 style="text-transform: uppercase">{{ media$['published_at'] | date: 'd MMMM y' }}</h5>
      <h1>{{ media$['title'] }}</h1>
      <p *ngIf="media$['thumbnail']" class="text-center">
        <img [src]="media$['thumbnail']" [alt]="media$['title']" style="max-height: 300px"/>
      </p>
      <scully-content></scully-content>

    </div>
  </div>
</div>
